import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import shuffle from 'lodash.shuffle';

const OrderEventsQuiz = ({ events }) => {
  const [quizEvents, setQuizEvents] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const validEvents = events
      .filter((e) => e.title && e.year && e.description)
      .slice(0, 5);
    setQuizEvents(shuffle(validEvents));
  }, [events]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = [...quizEvents];
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setQuizEvents(reordered);
  };

  const handleSubmit = () => setSubmitted(true);

  const isCorrectOrder = () => {
    const years = quizEvents.map((e) => parseInt(e.year));
    return years.every((val, i, arr) => i === 0 || arr[i - 1] <= val);
  };

  if (quizEvents.length === 0) {
    return (
      <div className="text-center text-gray-400 mt-10">
        ⚠️ Not enough valid events to start this quiz.
      </div>
    );
  }
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className="max-w-2xl mx-auto p-6 bg-gray-900 text-white rounded-lg shadow-xl mt-10">
        <h2 className="text-2xl font-bold mb-4 text-purple-400 text-center">
          🧩 Order the Events
        </h2>
        <p className="text-gray-400 text-sm mb-6 text-center">
          Drag the events into the correct order (earliest to latest)!
        </p>

        <Droppable droppableId="events">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`space-y-4 min-h-[300px] p-2 transition ${
                snapshot.isDraggingOver ? 'bg-purple-800/10' : ''
              }`}
            >
              {quizEvents.map((event, index) => {
                const key = `${event.title}-${event.year}-${index}`;
                return (
                  <Draggable key={key} draggableId={key} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`flex items-center gap-4 bg-gray-800 p-4 rounded-lg border shadow transition duration-200 ${
                          snapshot.isDragging ? 'border-purple-500 scale-105' : 'border-gray-700'
                        }`}
                        style={{ ...provided.draggableProps.style, userSelect: 'none' }}
                      >
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-600 text-white font-bold flex items-center justify-center">
                          {index + 1}
                        </div>
                        <div>
                          <h4 className="font-semibold">{event.title}</h4>
                          <p className="text-sm text-gray-400">{event.description}</p>

                          {submitted && (
                            <p className="text-xs text-green-400 mt-1">
                              📅 Year: {event.year}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>

        <div className="mt-6 text-center">
          {!submitted ? (
            <button
              onClick={handleSubmit}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg"
            >
              ✅ Submit Order
            </button>
          ) : isCorrectOrder() ? (
            <p className="text-green-400 font-semibold mt-4">🎉 Correct order!</p>
          ) : (
            <p className="text-red-400 font-semibold mt-4">
              ❌ Not quite right. Check the correct years above!
            </p>
          )}
        </div>
      </div>
    </DragDropContext>
  );
};

export default OrderEventsQuiz;
